import { useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import { useAcolherVisitantes } from "../context/getAcolher";
import { TVisitante } from "../services/getMembros";
import { useQuery } from "@tanstack/react-query";

interface useServicesVisitanteEditProps {

}

const useServicesVisitanteEdit = () => {

  const { id } = useParams();
  const {startLoading, stopLoading, isLoading} = useLoading();
  const { setMensagemError, setMensagemInfo } = useErrorSuccess();

  const { reset } = useAcolherVisitantes()

  const [visitante, setVisitante] = useState<TVisitante>();

  const alterVisitante = (field: keyof TVisitante, value: any) => setVisitante((_val) => ({..._val, [field]: value}));

  const getVisitante = async () => {
    startLoading();
    try {
      const req = await api.get('visitante/'+id);
      const res = await req.data;
      setVisitante(res);
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    } finally {
      stopLoading()
    }
  }

  const handleUpdate = async () => {
    if(isLoading) return;
    startLoading();

    try {

      const req = await api.put('visitante/'+id, visitante);
      const res = await req.data;
      setMensagemInfo('Visitante atualizado com sucesso!');

    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    } finally {
      await reset()
      stopLoading()

    }
  }

  const {} = useQuery({
    queryFn: getVisitante
  })

  return {
    isLoading,
    visitante,
    getVisitante,
    handleUpdate,
    alterVisitante
  };
}

export default useServicesVisitanteEdit;
